export class CouldNotRemoveLastAdminUserFromOrganization extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, CouldNotRemoveLastAdminUserFromOrganization.prototype)
  }
}
